import React, { FC } from 'react';
import { createColors } from '@shared/joykit/packages/core/common/themes/shared/colors/createColors';
import { Colors } from '@withjoy/joykit/theme';
import { iconScaleToSize } from '@withjoy/joykit/components/IconV2/Icon.styles';

type StarProps = {
  id: string;
  fillColor: keyof Colors;
  bgColor: keyof Colors;
  colorFilledFraction: string | number;
  iconSize?: number | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
};

export const Star: FC<StarProps> = props => {
  const { fillColor, bgColor, colorFilledFraction, id, iconSize = 'md' } = props;
  const colors = createColors();
  const size = `${typeof iconSize === 'number' ? iconSize : iconScaleToSize[iconSize]}px`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id={id}
          shapeRendering="crispEdges"
        >
          <stop
            offset={colorFilledFraction}
            stopColor={colors[fillColor] || fillColor}
          />
          <stop
            offset="0%"
            stopColor={colors[bgColor] || bgColor}
          />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${id})`}
        d="M3.37425 15.2936C3.34847 15.2936 3.32269 15.2856 3.30078 15.2697C3.25691 15.2378 3.2386 15.1813 3.25544 15.1297L5.00716 9.77492L0.441378 6.47148C0.39744 6.43967 0.379003 6.38317 0.395784 6.33158C0.412503 6.28008 0.460503 6.24517 0.514659 6.24517C0.514721 6.24517 0.514815 6.24517 0.514878 6.24517L6.15041 6.2553L7.88028 0.893234C7.89694 0.841641 7.94497 0.806641 7.99922 0.806641C8.05347 0.806641 8.10153 0.841609 8.11819 0.893234L9.8495 6.25533L15.4851 6.2452C15.4851 6.2452 15.4852 6.2452 15.4853 6.2452C15.5394 6.2452 15.5874 6.28008 15.6042 6.33161C15.6209 6.38317 15.6025 6.4397 15.5586 6.47152L10.9928 9.77495L12.7446 15.1298C12.7614 15.1813 12.7431 15.2379 12.6993 15.2698C12.6553 15.3016 12.5959 15.3016 12.5521 15.2696L7.99928 11.9485L3.44794 15.2696C3.426 15.2856 3.40013 15.2936 3.37425 15.2936Z"
      />
    </svg>
  );
};
